<div class="row">
    <div class="col-12">
        <p class="addition">
            <span
                [innerHTML]="'dynamische_frontend_texte.landing.html_content.ueberschrift' | translate | safeStyle"
            ></span>
        </p>
    </div>
    <otb-progress-bar></otb-progress-bar>
</div>
<form id="agency-service-selection" [formGroup]="serviceFormGroup" (ngSubmit)="onSubmit()">
    <div class="row">
        <div class="col-12 mb-4">
            <h2 [innerHTML]="'dynamische_frontend_texte.landing.html_content.einfuehrung' | translate | safeStyle"></h2>
        </div>
        <div class="col-12 col-sm-6">
            <div class="form-group">
                <label
                    for="citizen-service-only"
                    [innerHTML]="
                        'dynamische_frontend_texte.landing.html_content.label_dropdown_leistung'
                            | translate
                            | required
                            | safeStyle
                    "
                ></label>
                <ng-select
                    id="citizen-service-only"
                    [items]="servicesSelect"
                    bindLabel="name"
                    bindValue="id"
                    (change)="onServiceSelect($event)"
                    formControlName="service"
                    [clearable]="false"
                    [markFirst]="false"
                    placeholder="Dienstleistung auswählen"
                    notFoundText="Keine Einträge gefunden"
                    [inputAttrs]="{ 'aria-describedby': 'citizen-service-only-error citizen-service-only-hint' }"
                    dropdownCustomHoverColorDirective
                    otbAnnounceSearchResults
                ></ng-select>
                <span id="citizen-service-only-hint" class="visually-hidden">
                    {{ 'dynamische_frontend_texte.landing.attribute_text.hinweis_fokus_leistung' | translate }}
                </span>
                <otb-form-error-message
                    id="citizen-service-only-error"
                    [show]="formService.invalid && formService.dirty"
                ></otb-form-error-message>
            </div>
        </div>
        <div class="col-0 col-sm-6"></div>
        <div class="col-12 col-sm-6">
            @if (selectedService && selectedService.notice) {
                <section class="service-notice mt-3">
                    <h3
                        #serviceNoticeHeading
                        id="service-notice-heading"
                        class="description-title"
                        tabindex="-1"
                        [innerHTML]="
                            'dynamische_frontend_texte.landing.html_content.zusaetzliche_informationen'
                                | translate
                                | safeStyle
                        "
                    ></h3>
                    <div class="notice-text mt-2" [innerHTML]="selectedService.notice | safeStyle"></div>
                </section>
            }

            <button
                type="submit"
                class="btn-success btn rounded-0 float-end"
                accesskey="w"
                btnPrimaryColorDirective
                [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
            ></button>
        </div>
    </div>
</form>
